 <section class="wraper-sub">
  <div class="lead-m">
    <div class="top-page-m">
      <div class="top-section">
        <h1 class="page-name">Order Management</h1>
      </div>
    </div>
    <div class="pgContent">
        <div class="mainHead">
            <p class="pItem">View Order Details</p>
            <p class="cItem" *ngIf="orderDetail">- {{ orderDetail.order_id }}</p>
        </div>
        <h3 class="subHead">All Available Order Details</h3>
        <div *ngIf="orderDetail" class="detailForm orderDetailsWrapper">
            <div class="formCard">
                <ul class="statList">
                    <li>
                        <p class="itemTitle">Academic Level :</p>
                        <p class="itemInfo text-capitalize">{{orderDetail.level}}</p>
                    </li>
                    <li>
                        <p class="itemTitle">Due date & time :</p>
                        <p class="itemInfo" *ngIf="orderDetail.writer_delivery_date == '0000-00-00 00:00:00'">-</p>
                        <p class="itemInfo" *ngIf="orderDetail.writer_delivery_date != '0000-00-00 00:00:00'">{{orderDetail.writer_delivery_date | customDatePipe: 'dateTime' }}</p>
                    </li>
                    <li>
                        <p class="itemTitle">No. of pages :</p>
                        <ng-container *ngFor="let page of noOfPages">
                          <p class="itemInfo" *ngIf="page.value == orderDetail.pages">{{ page.label }}</p>
                        </ng-container>
                    </li>
                    <li>
                        <p class="itemTitle">Subject :</p>
                        <p class="itemInfo">{{orderDetail.subject}}</p>
                    </li>
                    <li>
                        <p class="itemTitle">Document Type :</p>
                        <p class="itemInfo">{{ orderDetail.work_type }} <span *ngIf="orderDetail.other_work_type">({{ orderDetail.other_work_type }})</span></p>
                    </li>
                    <li>
                        <p class="itemTitle">Title :</p>
                        <p class="itemInfo">{{orderDetail.title}}</p>
                    </li>
                    <li>
                        <p class="itemTitle">Citation style :</p>
                        <p class="itemInfo">{{orderDetail.citation}}</p>
                    </li>
                    <li>
                        <p class="itemTitle">No. of Sources :</p>
                        <p class="itemInfo">{{orderDetail.required_sources}}</p>
                    </li>
                    <li>
                        <p class="itemTitle">Status /Paid :</p>
                        <ng-container *ngFor="let status of orderStatus">
                          <p class="itemInfo" *ngIf="status.value == orderDetail.status">{{ status.name }}</p>
                        </ng-container>
                    </li>

                    <li>
                        <p class="itemTitle">Additional Requirements :</p>

                        <ul class="addonsList">
                          <li *ngIf="orderDetail.expert_level && orderDetail.expert_level > 0"><p class="itemInfo">Premium Expert</p></li>
                          <li *ngIf="orderDetail.originality_report && (orderDetail.originality_report != '0' && orderDetail.originality_report != 'null')"><p class="itemInfo">Originality Report</p></li>
                          <li *ngIf="orderDetail.full_text_sources && ( orderDetail.full_text_sources != '0' && orderDetail.full_text_sources != 'null')"><p class="itemInfo">Full text of sources</p></li>
                          <li *ngIf="orderDetail.high_priority_status && ( orderDetail.high_priority_status != '0' && orderDetail.high_priority_status != 'null')"><p class="itemInfo">High Priority Status</p></li>
                          <li *ngIf="orderDetail.proofread_editor && ( orderDetail.proofread_editor != '0' && orderDetail.proofread_editor != 'null')"><p class="itemInfo">Proofread by an Editor</p></li>
                          <li *ngIf="orderDetail.one_page_summary && ( orderDetail.one_page_summary != '0' && orderDetail.one_page_summary != 'null')"><p class="itemInfo">1-page summary</p></li>
                          <li *ngIf="orderDetail.simple_language && ( orderDetail.simple_language != '0' && orderDetail.simple_language != 'null')"><p class="itemInfo">Simple Language</p></li>
                          <li *ngIf="orderDetail.priority_support_text && ( orderDetail.priority_support_text != '0' && orderDetail.priority_support_text != 'null')"><p class="itemInfo">Get Priority Support via Text</p></li>
                        </ul>
                    </li>

                    <li *ngIf="activeUser.Portal_SuperAdmin">
                        <p class="itemTitle">School/Institution Name :</p>

                        <ng-container >
                          <p class="itemInfo">{{ orderDetail.school_or_institution_name }}</p>
                        </ng-container>
                    </li>
                </ul>
            </div>
            <div class="formCard detailedContent">
                <ul class="statList">
                    <li>
                        <p class="itemTitle">Attachments :</p>
                        <p class="itemInfo attachmentLinks" *ngIf="orderDetail.attachments && orderDetail.attachments.length > 0">
                          <ng-container *ngFor="let attach of orderDetail.attachments">
                            <a [href]="attach.link" target="_blank" *ngIf="attach.link">{{ attach.name }}</a>
                          </ng-container>
                        </p>
                    </li>
                    <li>
                        <p class="itemTitle">Instructions :</p>

                        <p class="itemInfo detailedText" style="white-space:pre-wrap;">
                          <span>{{ orderDetail.description }}</span>
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
  </div>
</section>
